import { ACTION_TYPES } from "./ActionTypes"

export const AddTab = (tabname : string) :{type:string,payload: string} => ({
    type:ACTION_TYPES.ADD_TAB,
    payload:tabname
})

export const RemoveTab = (tabname : string) => ({
    type:ACTION_TYPES.REMOVE_TAB,
    payload:tabname
})

export const TerminalToggle = (val :boolean) => ({
    type:ACTION_TYPES.TERMINAL_TOGGLE,
    payload:val
})

export const AdminLogin = (val :any) => ({
    type:ACTION_TYPES.ADMIN_LOGIN,
    payload:val
})

export const AdminLogout = (val :any) => ({
    type:ACTION_TYPES.ADMIN_LOGOUT,
    payload:val
})